import { Box, useTheme } from '@mui/material';
import { keyframes } from '@emotion/react';
import { PumpIcon } from 'src/assets/icons/PumpIcon';
import { Propeler } from 'src/assets/widgets/Propeler';

type Props = {
  width: number;
  height: number;
  isRunMode: boolean;
  isAlarmActive: boolean;
  propelerWidth: number;
};

export const RegularPumpWithPropeler = ({
  width,
  height,
  isAlarmActive,
  isRunMode,
  propelerWidth,
}: Props) => {
  const theme = useTheme();
  const primaryMainColor = theme.palette.primary.main;
  const greyColor = theme.palette.grey[400];
  const redColor = '#ff4842';

  let propelerColor = greyColor;
  let propelerTestId = 'offState';

  if (isAlarmActive) {
    propelerColor = redColor;
    propelerTestId = `activeAlarm-${isRunMode ? 'onState' : 'offState'}`;
  } else if (isRunMode && !isAlarmActive) {
    propelerColor = primaryMainColor;
    propelerTestId = 'onState';
  }
  const rotate = keyframes`
0% { transform: translate(-50%, -50%) rotate(0deg); }
100% { transform: translate(-50%, -50%) rotate(360deg); }
`;
  return (
    <Box>
      <PumpIcon width={width} height={height} />
      <Box
        position="absolute"
        top="64%"
        left="12%"
        data-sm={propelerTestId}
        sx={{
          width: propelerWidth,
          height: 30,
          transform: 'translate(-50%, -50%)',
          animation: isRunMode ? `${rotate} 1.5s linear infinite` : 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Propeler width={propelerWidth} height={100} fill={propelerColor} />
      </Box>
    </Box>
  );
};
